import { ButtonList } from '@dixa/lib-shared-habla';

type MimSidekickChoicesProps = {
  choices: string[];
  onSelect: (choice: string) => void;
};

/** Render this component when structured output present us with choices */
export const MimSidekickChoices = ({
  choices,
  onSelect,
}: MimSidekickChoicesProps): JSX.Element | null => {
  if (choices.length === 0) return null;

  return (
    <ButtonList>
      {choices.map((choice) => (
        <ButtonList.Item key={choice} onClick={() => onSelect(choice)}>
          {choice}
        </ButtonList.Item>
      ))}
    </ButtonList>
  );
};
